import { render } from "./AddTask.vue?vue&type=template&id=57e67e66&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"

import "./AddTask.vue?vue&type=style&index=0&id=57e67e66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\absan\\Documents\\GitHub\\Starport\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e67e66"]])

export default __exports__